/* eslint-disable @typescript-eslint/naming-convention */
import { Modal } from '@material-ui/core'
import MuiInfoIcon from '@mui/icons-material/Info'
import styled from '@emotion/styled'
import { colors, typography } from '@resiliatech/birdsong'

export const TaskModalContainer = styled(Modal)`
  align-items: center;
  display: flex;
  justify-content: center;
`

export const TaskModalContent = styled.div`
  background-color: ${colors.background.secondaryBackground};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  height: auto;
  max-height: 90vh;
  overflow-y: auto;
  padding: 40px;
  width: 768px;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const Header = styled.h5`
  ${typography.up2.regularSerif}
  margin: 0;
`

export const SubHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SubHeader = styled.h6`
  ${typography.up1.regularSerif}
  margin: 0;
`

export const Copy = styled.p`
  ${typography.baseline.regularSans}
  background-color: ${colors.background.secondaryBackground};
  margin: 0;
`

export const errStyles = {
  '& .MuiOutlinedInput-root': {
    '& fieldset': { borderColor: colors.feedback.errorDark },
    '&:hover fieldset': { borderColor: colors.feedback.errorDark },
    '&.Mui-focused fieldset': { borderColor: colors.feedback.errorDark },
  },
  '& .MuiInputLabel-root': { color: colors.feedback.errorDark },
  '& .MuiInputLabel-root.Mui-focused': { color: colors.feedback.errorDark },
}

export const dateInputStyles = {
  '& input': { padding: '16px' },
  '.MuiFormLabel-root': {
    paddingY: '8px',
  },
  '& .MuiInputLabel-root': {
    '&.MuiInputLabel-shrink': {
      paddingTop: '0px', // Padding when label is shrunk
    },
    paddingTop: '8px', // Default padding
  },
  width: '100%',
}

export const ErrorMessage = styled.p`
  ${typography.baseline.regularSans}
  color: ${colors.feedback.errorDark};
  margin: 0;
  font-size: 12px;
  padding: 0 14px;
`

export const TaskDetailsInputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 24px;
`

export const LinkInputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 16px;
`

export const TaskDueDateInputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 24px;
`

export const OptionalInputContainer = styled.span`
  padding-top: 16px;
`

export const IntervalOptions = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;
`

export const CheckboxesContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const Row = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`

export const CheckboxAndLabel = styled.div`
  align-items: center;
  display: flex;
`

export const DatePickersContainer = styled.div`
  display: flex;
  gap: 24px;
`

export const Footer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  height: 40px;
  justify-content: flex-end;
  margin-left: auto;
`

export const InfoIcon = styled(MuiInfoIcon)`
  color: ${colors.interactive.primaryEnabled};
  cursor: pointer;
`
